import type { Locale } from "../../../shared/types.js";

const LOCALE_MAP: Record<Locale, string> = {
  "pt-BR": "pt-BR",
  "en-US": "en-US",
  "es-ES": "es-ES",
};

/** Formats a billing date using the customer's app language (not the browser default). */
export function formatBillingDate(iso: string | Date, locale: string): string {
  const resolved = LOCALE_MAP[locale as Locale] ?? LOCALE_MAP["pt-BR"];
  const date = typeof iso === "string" ? new Date(iso) : iso;
  return date.toLocaleDateString(resolved, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/**
 * Day and time apart, for a deadline that ends mid-day (the 7-day refund window ends 168 h after
 * the charge): `{ date: "8 de outubro", time: "14:32" }`, joined by the locale's own words.
 */
export function formatBillingDayAndTime(iso: string | Date, locale: string): { date: string; time: string } {
  const resolved = LOCALE_MAP[locale as Locale] ?? LOCALE_MAP["pt-BR"];
  const value = typeof iso === "string" ? new Date(iso) : iso;
  return {
    date: value.toLocaleDateString(resolved, { day: "numeric", month: "long" }),
    time: value.toLocaleTimeString(resolved, { hour: "2-digit", minute: "2-digit" }),
  };
}
